import { useCurrentUser } from '../../../../../shared/features/session/components/CurrentUserProvider';
import { PasswordCard } from '../components/PasswordCard';
import { SignInCodesCard } from '../components/SignInCodesCard';
import { TwoFactorCard } from '../components/TwoFactorCard';
import { useSignInCodeChannels } from '../hooks/use-sign-in-code-channels';

/** The Security tab: where sign-in codes go, the optional password, and the two-factor that guards it. */
export function SecurityPage() {
  const { state } = useCurrentUser();
  const channels = useSignInCodeChannels();
  if (state.status !== 'authenticated') return null;
  const { user } = state;

  return (
    <div className="max-w-2xl space-y-4">
      <SignInCodesCard email={user.email} phone={user.phone} channels={channels} />
      <PasswordCard hasPassword={user.hasPassword} />
      <TwoFactorCard email={user.email} hasPassword={user.hasPassword} totpEnabled={user.totpEnabled} emailOtpEnabled={user.emailOtpEnabled} />
    </div>
  );
}
